<template>
    <div class="search-contents-wrap _free">

        <button type="button" class="mobile-back-btn" v-on:click="mobileSearchBack">
            <div class="md_icon-btn _small">
                <div class="inner"><SvgIconBack /></div>
            </div>
            <p>BACK</p>
        </button>

        <div class="scroll-inner">
            <div class="search-contents-inner">

                <div class="form_search">
                    <form v-on:submit.prevent="brandSearch">
                        <input type="search" id="free-word" placeholder="キーワードを入力" v-on:focus="onFocus" v-on:blur="onBlur" v-model="freeText">
                        <div class="icon">
                            <div class="md_svg-icon ">
                            <div class="inner" v-on:click="brandSearch()"><SvgIconSearch /></div>
                            <!-- <input type="submit" id="submit-btn"> -->
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div><!--/.search-contents-wrap._category-->
</template>

<script>

    //SvgIcon
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'

    export default {
        components: {
            //SvgIcon
            SvgIconBack,
            SvgIconSearch,
        },
        data() {
            return {
                freeText: "",
            }
        },
        methods: {
            ////////////////////////////////////
            //検索メニューMobile表示Backボタン
            ////////////////////////////////////
            mobileSearchBack: function () {
                this.tabSelectorActive = '';
                for (const element of document.getElementsByName('search-select')) {
                    element.checked = false;
                }
            },
            // フォーカスが外れた時に呼出されます。
            onBlur: function() {
                this.$store.state.search.form.freeText = this.freeText;
            },
            brandSearch() {
                this.$store.state.search.form.freeText = this.freeText;
                // var formData = this.$store.state.search.form;
                // var jsontext = JSON.stringify(formData)

                // var form = document.createElement('form');
                // form.action = '/brand-list';
                // form.method = 'POST';

                // var q = document.createElement('input');
                // q.value = jsontext;
                // q.name = 'form';
                // form.appendChild(q);

                // var csrf = document.createElement('input');
                // var token = $('[name="csrf-token"]').attr('content');
                // csrf.type = 'hidden';
                // csrf.name = '_token';
                // csrf.value = token;
                // form.appendChild(csrf);
                // document.body.appendChild(form);
                // form.submit();
                if (location.pathname == '/showroom-list') {
                    var url = '/showroom-list';
                } else {
                    var url = '/brand-list';
                }
                const form = reactive({
                    search_form: this.$store.state.search.form,
                })
                Inertia.get(url, form, {
                    onSuccess: (page) => {
                        location.reload();
                    },
                })
            },

        },
    }
</script>
